import { createSelector } from 'reselect';
import { getSensorReducerState } from '../rootSelectors';

const getIrisSensors = createSelector([getSensorReducerState], sensor => sensor.irisSensors);
const getSensorsConfigForIris = createSelector([getSensorReducerState], sensor => sensor.sensorsConfig);
const getSensorUnits = createSelector([getSensorReducerState], sensor => sensor.sensorUnits);

export { getIrisSensors, getSensorsConfigForIris, getSensorUnits };
